.editorial-container-mobile {
  position: relative;
  width: 100%;
  margin-bottom: 5rem;
  // no 'margin' needed since it works in dev/staging/prod

  .outfit {

    .outfit-image {
      margin-bottom: 1.5rem;

      img {
        width: 100%;
      }
    }

    .products {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      height: auto;

      .product {
        width: calc(50% - 0.5rem);
        margin-bottom: 1.5rem;
      }
    }
  }
}

.editorial-container-desktop {
  width: 100%;
  margin-bottom: 5rem;

  .row-1 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .key-image {
      width: 66%;
      margin-bottom: 66px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: auto 100%;

      img {
        width: 100%;
      }
    }

    .key-products {
      width: calc(33% - 1rem);

      .product {
        width: 100%;
        margin-bottom: 1.5rem;
      }
    }

    .remaining-key-products {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 1.5rem;

      .product {
        width: calc(33% - 0.8rem);
        margin: 0 0.8rem;

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .row-3 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .product {
      width: calc(33% - 1rem);
      margin-bottom: 1rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;

      &:nth-child(3n+1) {
        margin-left: 0;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }

      .hidden {
        visibility: hidden;
      }
    }
  }
}